<div
    [routerLink]="productLink"
    class="product-card__container m-0"
    [attr.title]="data.title ? 'Tour ' + data.title : 'Tour'"
    [attr.aria-label]="data.title ? 'Tour ' + data.title : 'Tour'"
>
    <p class="product-card__winner" *ngIf="isPopular">Travelers' Choice</p>

    <div class="product-card__overlay-img">
        <picture class="product-card__picture">
            <source *ngIf="imageUrl | toAvif as avif" [srcset]="avif" type="image/avif" />
            <img
                [src]="imageUrl"
                [alt]="imageAlt"
                width="1200"
                height="800"
                sizes="(max-width: 768px) 92vw, (max-width: 1200px) 48vw, 380px"
                loading="lazy"
                decoding="async"
                fetchpriority="low"
                class="overlay-img__img h-100 w-100"
            />
        </picture>

        <div class="product-card__price" *ngIf="data.nextDefaultPrice">
            <span class="product-card__price__from">FROM</span>
            <span class="product-card__price__amount">
                <span class="product-card__price__currency notranslate"
                      translate="no"
                      lang="en">USD</span>
                <span class="product-card__price__number notranslate"
                      translate="no">{{ data.nextDefaultPrice }}</span>
            </span>
        </div>

        <!-- <div class="product-card__tags row">
            <!-- [ngClass]="{'d-flex flex-column': data.privateActivity === false}"
            <div class="product-card__tags__badge col">
                <span>
                    <img
                        class="product-card__tags_badge"
                        src="../../../../assets/svg/ages.svg"
                        alt="ages"
                    />
                    <span *ngIf="data.minAge != 0"> {{ data.minAge }} +</span>
                    <span *ngIf="data.minAge == 0">All Ages</span>
                </span>
            </div>
            <div class="product-card__tags__badge col">
                <span>
                    <img
                        class="product-card__tags_badge"
                        src="../../../../assets/svg/calendar.svg"
                        alt="Dates"
                    />

                    <!-- *ngIf="data.minAge!=0" --
                    <!-- <span >Ages 2 +</span> --
                    <!-- {{data.minAge}}
                        *ngIf="data.minAge==0"--
                    <span>Daily</span>
                </span>
            </div>
            <div class="product-card__tags__badge col">
                <span>
                    <img
                        class="product-card__tags_badge"
                        src="../../../../assets/svg/bookmark.svg"
                        alt="Bookmark"
                    />
                    <span>
                        Food & Drink Tours
                        <!-- {{ data.durationText }} --
                    </span></span
                >
            </div>
            <div class="product-card__tags__badge col">
                <span>
                    <img
                        class="product-card__tags_badge"
                        src="../../../../assets/svg/hour.svg"
                        alt="Min Hours"
                    />
                    <span>
                        {{ data.durationText }}
                    </span></span
                >
            </div>
            <div class="product-card__tags__badge col">
                <! *ngIf="data.privateActivity === false" --
                <span>
                    <img
                        class="product-card__tags_badge"
                        src="../../../../assets/svg/shared.svg"
                        alt="Shared Tours"
                    />

                    <span>Shared Tours</span></span
                >
            </div>
        </div> -->
    </div>

    <div class="product-card__inner-text d-flex flex-column justify-content-between gap-2">
        <div class="text-start">
            <div class="product-card__meta" *ngIf="data.durationText || (data.reviewCount && data.reviewCount > 0)">
                <span class="product-card__meta-pill" *ngIf="data.durationText">
                    <img src="../../../../assets/svg/hour.svg" alt="Duration" width="14" height="14" loading="lazy" decoding="async" />
                    {{ data.durationText }}
                </span>
                <span class="product-card__meta-pill product-card__meta-pill--rating" *ngIf="data.reviewCount && data.reviewCount > 0">
                    <span class="product-card__star" aria-hidden="true">★</span>
                    {{ data.reviewRating | number:'1.1-1' }}
                    <span class="product-card__reviews">({{ data.reviewCount }})</span>
                </span>
            </div>

            <h3 class="product-card__title">{{ data.title }}</h3>
            <p class="product-card__text">{{ data.excerpt }}</p>
        </div>

        <app-primary-button
            [link]="productLink"
            [text]="'BOOK NOW'"
            [ariaLabel]="data.title ? 'Tour ' + data.title : 'Tour'"
        ></app-primary-button>
    </div>
</div>
